module.exports = __webpack_public_path__ + "static/media/bnr14.46997225.jpg";